import { useEffect, useState } from "react";
import { setUpsellHandler } from "../utils/upsellBus";
import UpsellModal from "../components/upsell/UpsellModal";

/**
 * App-root provider that owns the single upsell modal. The axios interceptor calls triggerUpsell()
 * on a SUBSCRIPTION_LIMIT_REACHED error; we open the modal here. The modal is a pure overlay — it
 * never touches the page underneath, so whatever the user was filling in stays intact.
 */
export const UpsellProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  // Which quota ran out, when the caller knew. Lets the modal offer just the add-on that fixes it.
  const [limitCode, setLimitCode] = useState(null);

  useEffect(() => {
    setUpsellHandler(({ message: msg, limitCode: code }) => {
      setMessage(msg || "");
      setLimitCode(code || null);
      setOpen(true);
    });
    return () => setUpsellHandler(null);
  }, []);

  return (
    <>
      {children}
      <UpsellModal
        isOpen={open}
        message={message}
        limitCode={limitCode}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default UpsellProvider;
